var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tag-sections" }, [
      _c(
        "section",
        { staticClass: "tag" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("HomeOffice", {
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.homeOffice,
              callback: function($$v) {
                _vm.homeOffice = $$v
              },
              expression: "homeOffice"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "tag" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("Geo", {
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.geo,
              callback: function($$v) {
                _vm.geo = $$v
              },
              expression: "geo"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "has-sub" }, [
      _vm._v("\n\t\t\t\tMöchtest du Homeoffice / Remote Work?\n\t\t\t\t"),
      _c("span", { staticClass: "sub" }, [
        _vm._v("Details findest Du später bei den Jobs.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }